module.exports = __webpack_public_path__ + "img/arc.13ef92d5.svg";